/** Množství v jazyce uživatele (desetinná čárka), bez zbytečných nul (R-13: až 3 desetinná místa). */
export function formatQuantity(value: number, language: string): string {
  return new Intl.NumberFormat(language === "vi" ? "vi-VN" : "cs-CZ", { maximumFractionDigits: 3 }).format(value);
}
